import React from 'react';
import styles from './SettingsTable.module.scss';
import { useTranslation } from 'react-i18next';
import { TableItem } from '../TableItem/TableItem';

export const SettingsTable = ({ mediumType, item, changeSetting, isEnabled }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.notificationSettingsContainer}>
      <div className={styles.engagementContainer}>
        <span className={styles.engagementTitle}>{t(item.label)}</span>

        {item.actions
          ?.filter(({ medium }) => medium === mediumType)
          ?.map(action => (
            <TableItem key={action.id} action={action} changeSetting={changeSetting} isEnabled={isEnabled} />
          ))}
      </div>
    </div>
  );
};
